// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Megaphone: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 44"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M52.1 17.8c0-2.1-1.4-3.9-3.3-4.5V1.9c0-.4-.2-.9-.6-1.1-.4-.3-.8-.3-1.2-.2L23 8.9H8.1c-1.7 0-3 1.4-3 3v1.3C2.7 13.8.9 16 .9 18.6S2.6 23.4 5 24v1.3c0 1.7 1.4 3 3 3h2.8v10.3c0 2.6 2.1 4.7 4.7 4.7s4.7-2.1 4.7-4.7V28.4h2.6L47 35.9c.1 0 .3.1.4.1.3 0 .6-.1.8-.3.4-.3.6-.7.6-1.1V22.3c1.9-.6 3.3-2.4 3.3-4.5zm-48.5.9c0-1 .6-2 1.4-2.4v4.9c-.8-.6-1.4-1.5-1.4-2.5zm14 20c0 1.1-.9 2-2 2s-2-.9-2-2V28.4h3.9v10.3zm4.2-13.1H8.1c-.2 0-.3-.1-.3-.3V12c0-.2.1-.3.3-.3h13.7v13.9zM46 32.7L24.5 26V11.3L46 3.8v28.9zm2.8-13.5v-2.8c.4.4.6.9.6 1.4s-.2 1.1-.6 1.4z"/></svg>;
};

export default React.memo(Megaphone);
